// extracted by mini-css-extract-plugin
module.exports = {"resultModal":"styles_resultModal__80iFi","content":"styles_content__3T89H","text":"styles_text__11_EU"};